<template>
  <figure class="picture">
    <img :alt="alt" :src="src">
    <figcaption v-html="alt"></figcaption>
  </figure>
</template>
<script>
  export default {
    name: 'ProductPicture',
    props: ['alt', 'src']
  };

</script>
<style scoped>
  .picture {
    max-width: 30vw;
    font-style: inherit;
    font-size: inherit;
    padding: 10px;
  }
  img {
    max-width: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/picture_el.vue